import { useHttp } from '../http'

export const useExternalContentHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`external-contents/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`external-contents`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`external-contents/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`external-contents`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`external-contents/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}
